import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tabs,
  Tab,
  Box,
  FormControl,
  Checkbox,
  ListItemText,
  Stack,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Typography,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import {
  HOSTNAME,
  INTRANETHOSTNAME,
  REPORT_HOSTNAME,
} from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/pl-report";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import "./index.scss";
import { tokenMainKeys, appSlugs } from "../../../../utils/constants";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import ClearIcon from "@mui/icons-material/Clear";
import SalesTrends from "./trends.js";
import { toast } from "react-toastify";

import {
  CIRCLE,
  METRIC_KEYS,
  MONTHLY_METRIC_KEYS,
  REGIONS,
  SCOPE_FILTER_TYPES,
} from "./helper.js";
import ScoreCards from "./score-cards.js";
import FileUpload from "../../../common-utilities/core/file-uploader/index.js";
import MultiSelectAutoComplete from "../../../common-utilities/components/mutli-select-autocomplete/MultiSelectAutocomplete.js";
import { getOfflineData } from "../../utils/offline-services.js";

// Map visible scope label -> backend filter id
export const SCOPE_TO_ID = {
  Region: "region",
  Circle: "circle",
  "Area Manager": "am",
  "Ops Manager": "opsManager",
  "Store Code": "storeCode",
  "Store Opening Date": "storeOpeningDate",
  City: "city",
  Format: "format",
  Type: "type",
  Cohort: "priceCohort",
  Tier: "tier",
};

const Sales = ({
  token = tokenMainKeys.plReport,
  slug = appSlugs.plReport,
}) => {
  const userDetails = getOfflineData("user", token) || {};
  const { role = "" } = userDetails;
  const [agg, setAgg] = useState("weekly");
  const [dateRanges, setDateRanges] = useState({});
  const [areaManagers, setAreaManagers] = useState([]);
  const [opsList, setOpsList] = useState([]);
  const [viewAreaManagers, setViewAreaManagers] = useState([]);
  const [viewOpsList, setViewOpsList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [isCallApi, setIsCallApi] = useState(true);
  const [isCallApiForView, setIsCallApiForView] = useState(true);
 const [storeOpeningStart, setStoreOpeningStart] = useState(null);
  const [storeOpeningEnd, setStoreOpeningEnd] = useState(null);
  const [filterOptions, setFilterOptions] = useState({
    storeCode: [],
    type: [],
    region: [],
    city: [],
    circle: [],

    format: [],
    priceCohort: [],
    tier: [],
    selectedFilters: [],
  });
  const [viewFilterOptions, setViewFilterOptions] = useState({
    storeCode: [],
    type: [],
    region: [],
    city: [],
    circle: [],

    format: [],
    priceCohort: [],
    tier: [],
    selectedFilters: [],
  });

  const [filters, setFilters] = useState({
    page: 1,
    selectedFilters: [],
    viewSelectedFilters: [
      [
        {
          id: "region",
          value: REGIONS,
        },
        {
          id: "circle",
          value: CIRCLE,
        },
      ],
    ],
    scope: [],
    viewScope: [
      { id: "region", label: "Region", allowedRoles: [] },
      { id: "circle", label: "Circle", allowedRoles: [] },
    ],
    scopeValues: {},
    viewScopeValues: {
      Region: REGIONS,
      Circle: CIRCLE,
    },
    regionValue: [],
    circleValue: [],
    areaManagerValue: [],
    opsManagerValue: [],
    storeCodeValue: [],
    cityValue: [],
    formatValue: [],
    typeValue: [],
    priceCohortValue: [],
    metric: [],
  });

  const [searchTrigger, setSearchTrigger] = useState(false);
  const [isDownload, setIsDownload] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);

  const getCommaSeparatedSummary = (values = [], maxChars = 32) => {
    if (!Array.isArray(values) || values.length === 0) return "";
    const mapped = values
      .map((v) => v?.label || v?.name || v?.value || v)
      .filter(Boolean);
    const text = mapped.join(", ");
    if (text.length <= maxChars) return text;
    const truncated = text.slice(0, maxChars - 1);
    return `${truncated}…`;
  };

  const payloadHandler = (isView = false, excludeStoreOpening = false) => {
    const payload = {};
    if (isView) {
      (filters.viewSelectedFilters || []).forEach((filter) => {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter.value.map((v) => v.value ?? v);
        }
      });
    } else {
      (filters.selectedFilters || []).forEach((filter) => {
    
        if (filter.id === "storeOpeningDate") {
          if (excludeStoreOpening) return;
    
          if (typeof filter.value === "object" && filter.value !== null) {
            if (filter.value.startDate && filter.value.endDate) {
              payload[filter.id] = filter.value;
            }
          }
        } else if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter.value.map((v) => v.value ?? v);
        }
      });
    }

    return payload;
  };
  const loadFilterOptions = useCallback(
    (isView = false) => {
    const payload = payloadHandler(isView, true);
      invokeApi(
        HTTP_METHODS.POST,
        `${REPORT_HOSTNAME}${REST_URLS.PL_FFILTERS}`,
        payload,
        null,
        null,
        slug,
        token
      )
        .then((res) => {
          if (!res?.message) {
            const storeCode = (res?.storeName || []).map((ele) => ({
              label: `${ele.storeCode}-${ele.storeName}`,
              value: ele.storeCode,
              id: ele.storeCode,
            }));
            const city = (res?.city || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const circle = (res?.circle || []).map((ele) => ({
              label: ele,
              value: ele,
            }));

            const format = (res?.format || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const priceCohort = (res?.priceCohort || []).map((ele) => ({
              label: ele,
              value: ele,
            }));

            const region = (res?.region || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const type = (res?.type || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const tier = (res?.tier || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            if (isView) {
              setViewFilterOptions((prevVal) => ({
                ...prevVal,
                storeCode,
                city,
                circle,
                region,
                format,
                priceCohort,
                type,
                tier,
              }));
            } else {
              setFilterOptions((prevVal) => ({
                ...prevVal,
                storeCode,
                city,
                circle,
                region,
                format,
                priceCohort,
                type,
                tier,
              }));
            }
          }
        })
        .catch((err) => console.error(err));
    },
    [filters.selectedFilters, slug, token, filters.viewSelectedFilters]
  );

  const loadManager = useCallback(
    (isView = false) => {
    const payload = payloadHandler(false, false);
      invokeApi(
        HTTP_METHODS.POST,
        `${REPORT_HOSTNAME}${REST_URLS.MANAGER_LIST}`,
        payload,
        {
          additionalRole: "am",
        },
        null,
        null,
        "operations-kpi"
      )
        .then((response) => {
          if (Array.isArray(response) && response.length > 0) {
            if (isView) {
              setViewAreaManagers(
                response.map((r) => ({
                  ...r,
                  label: r.name,
                  value: r.id ?? r.name,
                }))
              );
            } else {
              setAreaManagers(
                response.map((r) => ({
                  ...r,
                  label: r.name,
                  value: r.id ?? r.name,
                }))
              );
            }
          } else {
            if (isView) setViewAreaManagers([]);
            setAreaManagers([]);
          }
        })
        .catch((e) => {
          console.error("Error loading area managers", e);
        });
    },
    [filters.selectedFilters, filters.viewSelectedFilters]
  );

  const loadOpsManager = useCallback(
    (isView = false) => {
      const payload = payloadHandler(false, false);

      invokeApi(
        HTTP_METHODS.POST,
        `${INTRANETHOSTNAME}${REST_URLS.MANAGER_LIST}`,
        payload,
        { additionalRole: "opsManager" },
        null,
        null,
        "operations-kpi"
      )
        .then((res) => {
          if (!res?.message) {
            const users =
              res?.map?.((item) => ({
                label: item.name || item.email,
                value: item.id,
                id: item.id,
              })) || [];
            if (isView) {
              setViewOpsList(users);
            } else {
              setOpsList(users);
            }
          }
        })
        .catch((err) => {
          console.log("Error occcurred getting user list", err);
        });
    },
    [filters.selectedFilters, filters.viewSelectedFilters]
  );

  useEffect(() => {
    const selected = [];
    Object.entries(filters.scopeValues || {}).forEach(([scopeLabel, vals]) => {
      const id = SCOPE_TO_ID[scopeLabel];

        if (!id) return;
      // special case for storeOpeningDate which is an object with startDate/endDate
      if (scopeLabel === "Store Opening Date" && typeof vals === "object" && vals.startDate && vals.endDate) {
        selected.push({ id, value: vals });
      } else if (Array.isArray(vals) && vals.length > 0) {
        selected.push({ id, value: vals });
      }
   
    });

    // ---- VIEW FILTERS ----
    const viewSelected = [];
    Object.entries(filters.viewScopeValues || {}).forEach(
      ([scopeLabel, vals]) => {
        const id = SCOPE_TO_ID[scopeLabel];
        if (!id) return;
        if (Array.isArray(vals) && vals.length > 0) {
          viewSelected.push({ id, value: vals });
        }
      }
    );

    const stringifiedOld = JSON.stringify(filters.selectedFilters || []);
    const stringifiedNew = JSON.stringify(selected || []);
    if (stringifiedOld !== stringifiedNew) {
      setFilters((prev) => ({ ...prev, selectedFilters: selected }));
    }

    const stringifiedOldView = JSON.stringify(
      filters.viewSelectedFilters || []
    );
    const stringifiedNewView = JSON.stringify(viewSelected || []);
    if (stringifiedOldView !== stringifiedNewView) {
      setFilters((prev) => ({ ...prev, viewSelectedFilters: viewSelected }));
    }
  }, [filters.scopeValues, filters.viewScopeValues]);

  useEffect(() => {
    if (isCallApi) {
      loadFilterOptions();
      loadManager();
      loadOpsManager();
    }
  }, [filters.selectedFilters, isCallApi]);
    useEffect(() => {
      if (!filters.scope.some((s) => s.label === "Store Opening Date")) {
        setStoreOpeningStart(null);
        setStoreOpeningEnd(null);
      }
    }, [filters.scope]);
  useEffect(() => {
    if (isCallApiForView) {
      loadFilterOptions(true);
      loadManager(true);
      loadOpsManager(true);
    }
  }, [filters.viewSelectedFilters, isCallApiForView]);

  const handleClearStartDate = () => {
    setStartDate(null);
    setDateRanges((prev) => {
      const copy = { ...prev };
      delete copy.startMonth;
      delete copy.startYear;
      return copy;
    });
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="operations-kpi-container">
      <Stack direction="row" justifyContent="space-between" sx={{}}>
        {
          <Stack className="pl-filter-container" direction="row" spacing="1">
            {/* Metric selector only when needed */}
            {tabIndex === 1 && (
              <Autocomplete
                multiple
                options={
                  agg === "monthly"
                    ? [...METRIC_KEYS, ...MONTHLY_METRIC_KEYS]
                    : METRIC_KEYS
                }
                value={filters.metric || []}
                onChange={(event, newValue) => {
                  setFilters((prev) => ({ ...prev, metric: newValue }));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Metric" />
                )}
                size="small"
                sx={{ minWidth: 300 }}
              />
            )}
            {tabIndex === 0 && (
              <>
                <Autocomplete
                  multiple
                  size="small"
                  sx={{ minWidth: 300 }}
                  options={SCOPE_FILTER_TYPES}
                  value={filters.scope}
                  onChange={(event, newValue) => {
                    setFilters((prev) => {
                      const newScope = newValue || [];
                      const keptScopeValues = Object.fromEntries(
                        Object.entries(prev.scopeValues || {}).filter(([key]) =>
                          newScope.some((s) => s.label === key)
                        )
                      );
                      return {
                        ...prev,
                        scope: newScope,
                        scopeValues: keptScopeValues,
                      };
                    });
                  }}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Filters" variant="outlined" />
                  )}
                />
                {(filters.scope || []).map((scopeObj) => {
                  const scope = scopeObj.label;
                  const currentValue = filters.scopeValues[scope] || [];
            if (scope === "Store Opening Date") {
              return (
                <Stack direction="row" spacing={1} key={scope} alignItems="center">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Start Date"
                      value={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningStart(value);
                        const startStr = value ? value.format("YYYY-MM-DD") : null;
                        const endStr = storeOpeningEnd
                          ? storeOpeningEnd.format("YYYY-MM-DD")
                          : null;

                        // only update when both exist and valid
                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          // clear incomplete range
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningStart && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningStart(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="End Date"
                      value={storeOpeningEnd}
                      minDate={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningEnd(value);
                        const startStr = storeOpeningStart
                          ? storeOpeningStart.format("YYYY-MM-DD")
                          : null;
                        const endStr = value
                          ? value.format("YYYY-MM-DD")
                          : null;

                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningEnd && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningEnd(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              );
            }

                  const optionsMap = {
                    Region: filterOptions.region || [],
                    Circle: filterOptions.circle || [],
                    "Area Manager": areaManagers,
                    "Ops Manager": opsList,
                    "Store Code": filterOptions.storeCode || [],
                    City: filterOptions.city || [],

                    Format: filterOptions.format || [],
                    Type: filterOptions.type || [],
                    Cohort: filterOptions.priceCohort || [],
                    Tier: filterOptions.tier || [],
                  };

                  const allOptions = optionsMap[scope] || [];

                  return (
                    <MultiSelectAutoComplete
                      key={scope}
                      label={scope}
                      options={allOptions}
                      value={currentValue}
                      setIsCallApiForView={setIsCallApi}
                      onChange={(newValue) => {
                        setFilters((prev) => ({
                          ...prev,
                          scopeValues: {
                            ...prev.scopeValues,
                            [scope]: newValue,
                          },
                        }));
                      }}
                    />
                  );
                })}
              </>
            )}

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label={"Select Month and Year"}
                views={["month", "year"]}
                minDate={moment("2000-01-01")}
                maxDate={moment("2099-12-31")}
                disabled={tabIndex === 3}
                value={startDate}
                onChange={(value) => {
                  if (value) {
                    const year = value.year();
                    const month = value.month() + 1;

                    setDateRanges((prevVal) => ({
                      ...prevVal,
                      startMonth: month,
                      startYear: year,
                    }));
                    setStartDate(value);
                  } else {
                    handleClearStartDate();
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    className="new-textfield"
                    size="small"
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end">
                          {startDate && (
                            <IconButton
                              onClick={handleClearStartDate}
                              sx={{ padding: "0px" }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                          {params.InputProps.endAdornment}
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </LocalizationProvider>

            <Button
              variant="contained"
              onClick={() => {
                setSearchTrigger((s) => !s);
              }}
            >
              SEARCH
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setIsDownload(true);
              }}
            >
              Download
            </Button>
            {role?.toLowerCase() === "admin" && (
              <FileUpload
                uploadText="Upload"
                id="sales-uplaod"
                size="medium"
                color="warning"
                clsName="pl-spidle-upload-file"
                url={`${REPORT_HOSTNAME}${REST_URLS.OPS_UPLOAD}`}
                callBack={() => setSearchTrigger(true)}
              />
            )}
          </Stack>
        }

        <FormControl sx={{ minWidth: "fit-content" }}>
          <FormLabel id="demo-row-radio-buttons-group-label">
            Report Type
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={agg}
            onChange={(e) => setAgg(e.target.value)}
          >
            <FormControlLabel
              value="weekly"
              control={<Radio />}
              label="Weekly"
            />
            <FormControlLabel
              value="monthly"
              control={<Radio />}
              label="Monthly"
            />
          </RadioGroup>
        </FormControl>
      </Stack>
      {tabIndex === 1 && (
        <>
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              padding: "10px",
              borderRadius: "5px",
              paddingTop: "20px",
              position: "relative",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
              width: "fit-content",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                position: "absolute",
                top: -8,
                left: 12,
                px: 0.5,
                background: "#f6f6f6",
                color: "#6b7280",
              }}
            >
              Select View
            </Typography>

            {/* Main view scope selector */}
            <Autocomplete
              multiple
              size="small"
              sx={{ minWidth: 300 }}
              options={SCOPE_FILTER_TYPES}
              value={filters?.viewScope}
              onChange={(event, newValue) => {
                setFilters((prev) => {
                  const newScope = newValue || [];
                  const keptScopeValues = Object.fromEntries(
                    Object.entries(prev.viewScopeValues || {}).filter(([key]) =>
                      newScope.some((s) => s.label === key)
                    )
                  );
                  return {
                    ...prev,
                    viewScope: newScope,
                    viewScopeValues: keptScopeValues,
                  };
                });
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.label === value.label
              }
              renderInput={(params) => (
                <TextField {...params} label="View" variant="outlined" />
              )}
            />

            {/* Render view filters dynamically */}
            {(filters.viewScope || []).map((scopeObj) => {
              const scope = scopeObj.label;
              const currentValue = filters?.viewScopeValues[scope] || [];

              const optionsMap = {
                Region: viewFilterOptions.region || [],
                Circle: viewFilterOptions.circle || [],
                "Area Manager": viewAreaManagers,
                "Ops Manager": viewOpsList,
                "Store Code": viewFilterOptions.storeCode || [],
                City: viewFilterOptions.city || [],
                Format: viewFilterOptions.format || [],
                Type: viewFilterOptions.type || [],
                Cohort: viewFilterOptions.priceCohort || [],
                Tier: viewFilterOptions.tier || [],
              };

              const allOptions = optionsMap[scope] || [];

              return (
                <Autocomplete
                  key={scope}
                  multiple
                  disableCloseOnSelect
                  options={[
                    { sentinel: "__SELECT_ALL__", label: "Select All" },
                    { sentinel: "__CLEAR__", label: "Clear" },
                    ...allOptions,
                  ]}
                  value={currentValue}
                  isOptionEqualToValue={(option, value) => {
                    if (option?.sentinel && value?.sentinel)
                      return option.sentinel === value.sentinel;
                    return (
                      (option?.id ?? option?.value ?? option) ===
                      (value?.id ?? value?.value ?? value)
                    );
                  }}
                  renderTags={() =>
                    getCommaSeparatedSummary(
                      (currentValue || []).map(
                        (m) => m?.name || m?.label || m?.value || m
                      ),
                      14
                    )
                  }
                  getOptionLabel={(option) =>
                    option?.label || option?.name || option?.value || option
                  }
                  onBlur={() =>
                    setTimeout(() => setIsCallApiForView(true), 200)
                  }
                  onChange={(event, newValue, reason, details) => {
                    const toggled = details?.option;
                    setIsCallApiForView(false);

                    // Handle select all
                    if (toggled?.sentinel === "__SELECT_ALL__") {
                      setFilters((prev) => ({
                        ...prev,
                        viewScopeValues: {
                          ...prev.viewScopeValues,
                          [scope]: allOptions,
                        },
                      }));
                      return;
                    }

                    // Handle clear
                    if (toggled?.sentinel === "__CLEAR__") {
                      setFilters((prev) => ({
                        ...prev,
                        viewScopeValues: {
                          ...prev.viewScopeValues,
                          [scope]: [],
                        },
                      }));
                      setIsCallApiForView(true);
                      return;
                    }

                    // Handle normal selection
                    const cleaned = newValue.filter((v) => !v?.sentinel);
                    setFilters((prev) => ({
                      ...prev,
                      viewScopeValues: {
                        ...prev.viewScopeValues,
                        [scope]: cleaned,
                      },
                    }));
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      key={
                        option?.sentinel ||
                        option?.id ||
                        option?.value ||
                        option?.label
                      }
                    >
                      <Checkbox checked={selected} />
                      <ListItemText
                        primary={
                          option?.label ||
                          option?.name ||
                          option?.value ||
                          option?.sentinel ||
                          ""
                        }
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} size="small" label={scope} />
                  )}
                  sx={{ width: 300 }}
                />
              );
            })}
          </Box>
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              padding: "10px",
              borderRadius: "5px",
              paddingTop: "20px",
              position: "relative",
              display: "flex",
              gap: "10px",
              marginTop: "10px",
              width: "fit-content",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                position: "absolute",
                top: -8,
                left: 12,
                px: 0.5,
                background: "#f6f6f6",
                color: "#6b7280",
              }}
            >
              Select Filters
            </Typography>

            <>
              <Autocomplete
                multiple
                size="small"
                sx={{ minWidth: 300 }}
                options={SCOPE_FILTER_TYPES}
                value={filters.scope}
                onChange={(event, newValue) => {
                  setFilters((prev) => {
                    const newScope = newValue || [];
                    const keptScopeValues = Object.fromEntries(
                      Object.entries(prev.scopeValues || {}).filter(([key]) =>
                        newScope.some((s) => s.label === key)
                      )
                    );
                    return {
                      ...prev,
                      scope: newScope,
                      scopeValues: keptScopeValues,
                    };
                  });
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.label === value.label
                }
                renderInput={(params) => (
                  <TextField {...params} label="Filters" variant="outlined" />
                )}
              />
              {(filters.scope || []).map((scopeObj) => {
                const scope = scopeObj.label;
                const currentValue = filters.scopeValues[scope] || [];
  if (scope === "Store Opening Date") {
              return (
                <Stack direction="row" spacing={1} key={scope} alignItems="center">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Start Date"
                      value={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningStart(value);
                        const startStr = value ? value.format("YYYY-MM-DD") : null;
                        const endStr = storeOpeningEnd
                          ? storeOpeningEnd.format("YYYY-MM-DD")
                          : null;

                        // only update when both exist and valid
                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          // clear incomplete range
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningStart && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningStart(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="End Date"
                      value={storeOpeningEnd}
                      minDate={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningEnd(value);
                        const startStr = storeOpeningStart
                          ? storeOpeningStart.format("YYYY-MM-DD")
                          : null;
                        const endStr = value
                          ? value.format("YYYY-MM-DD")
                          : null;

                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningEnd && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningEnd(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              );
            }
                const optionsMap = {
                  Region: filterOptions.region || [],
                  Circle: filterOptions.circle || [],
                  "Area Manager": areaManagers,
                  "Ops Manager": opsList,
                  "Store Code": filterOptions.storeCode || [],
                  City: filterOptions.city || [],

                  Format: filterOptions.format || [],
                  Type: filterOptions.type || [],
                  Cohort: filterOptions.priceCohort || [],
                  Tier: filterOptions.tier || [],
                };

                const allOptions = optionsMap[scope] || [];
                return (
                  <MultiSelectAutoComplete
                    key={scope}
                    label={scope}
                    options={allOptions}
                    value={currentValue}
                    setIsCallApiForView={setIsCallApiForView}
                    onChange={(newValue) => {
                      setFilters((prev) => ({
                        ...prev,
                        scopeValues: {
                          ...prev.scopeValues,
                          [scope]: newValue,
                        },
                      }));
                    }}
                  />
                );
              })}
            </>
          </Box>
        </>
      )}

      {/* Tabs */}
      <Box sx={{ mt: 1 }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Score Card" />
          <Tab label="Trends" />
        </Tabs>
      </Box>

      {tabIndex === 0 && (
        <Box>
          <ScoreCards
            filters={filters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            agg={agg}
            payloadHandler={payloadHandler}
          />
        </Box>
      )}

      {tabIndex === 1 && (
        <Box>
          <SalesTrends
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            agg={agg}
            payloadHandler={payloadHandler}
          />
        </Box>
      )}
    </div>
  );
};

export default Sales;
